/** Public UI locale: Ukrainian + English. Persisted so landing and login stay in sync. */

export const LOCALE_STORAGE_KEY = 'uscada_locale';

const VALID = new Set(['uk', 'en']);

export function detectBrowserLocale() {
  if (typeof navigator === 'undefined') return 'en';
  const list = [];
  if (Array.isArray(navigator.languages) && navigator.languages.length) {
    list.push(...navigator.languages);
  } else if (navigator.language) {
    list.push(navigator.language);
  }
  for (const raw of list) {
    const code = String(raw || '').toLowerCase().split('-')[0];
    if (code === 'uk') return 'uk';
  }
  return 'en';
}

export function getSavedLocale() {
  try {
    const v = String(localStorage.getItem(LOCALE_STORAGE_KEY) || '').toLowerCase();
    return VALID.has(v) ? v : null;
  } catch {
    return null;
  }
}

export function getInitialPublicLocale() {
  return getSavedLocale() || detectBrowserLocale();
}

export function savePublicLocale(lang) {
  const v = String(lang || '').toLowerCase();
  if (!VALID.has(v)) return;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, v);
  } catch {
    /* ignore */
  }
}
